module.exports = __webpack_public_path__ + "img/success.e7ca61c5.png";